import convertToBasketItem from "./convertToBasketItem";
import { FormValue } from "../NewOrderAndReturnForm/types";
import {
  BasketItem,
  Currency,
  SubmissionResultItem,
  Summary
} from "../../containers/NewOrderContainer/types";
import { Reducer } from "react";
import { act } from "react-dom/test-utils";

type State = {
  formValue: FormValue;
  openConfirmDialog: boolean;
  openSubmitDialog: boolean;
  currencies?: Currency[];
  summary?: Summary;
  // onCurrencyAmountChange?: (v: number | null) => {};
  // onCurrencyChange?: (v: string | null) => {};
  // onSettlementSourceChange?: (v: string | null) => {};
  // onConfirmOrder?: () => {};
  // onAddToBasket?: (v: BasketItem) => {};
  isDirty?: boolean;
  clickedActionButton?: boolean;
  defaultRequiredDate?: string;
  submissionResultItems?: SubmissionResultItem[];
};

type ReducerAction = {
  type:
    | "Reset"
    | "NewFormValue"
    | "ClearForm"
    | "KeepForm"
    | "ClearReturnForm"
    | "Clear"
    | "SubmitBasket"
    | "CancelSubmitBasket"
    | "SubmitOrder"
    | "SetProps"
    | "SetDirty";
  payload?: {
    clickedActionButton?: boolean;
    isDirty?: boolean;
    currency?: string;
    currencyAmount?: number;
    submissionResultItems?: SubmissionResultItem[];
  };
};

const reducer = (state: State, action: ReducerAction) => {
  switch (action.type) {
    case "Reset": {
      return {
        ...state,
        openConfirmDialog: false,
        openSubmitDialog: false,
        formValue: { selectedDate: state.defaultRequiredDate },
        isDirty: false
      };
    }
    case "NewFormValue": {
      return {
        ...state,
        formValue: action.payload
      };
    }
    case "ClearForm": {
      return {
        ...state,
        clickedActionButton: false,
        isDirty: false,
        formValue: {
          branchId: state.formValue.branchId,
          currencyAmount: NaN,
          selectedDate: state.defaultRequiredDate,
          settlementSource: state.formValue.settlementSource
        }
      };
    }
    case "ClearReturnForm": {
      return {
        ...state,
        isDirty: false,
        clickedActionButton: false,
        formValue: {
          branchId: state.formValue.branchId,
          currencyAmount: NaN,
          selectedDate: state.defaultRequiredDate
        }
      };
    }
    case "KeepForm": {
      return {
        ...state,
        clickedActionButton: true,
        isDirty: true
      };
    }
    // case "AddToBasketOrders": {
    //   if (
    //     state.onAddToBasket &&
    //     state.formValue.branchId &&
    //     state.formValue.currency &&
    //     state.formValue.currencyAmount &&
    //     state.formValue.denominations &&
    //     state.formValue.denominations.length > 0
    //   ) {
    //     state.onAddToBasket(
    //       convertToBasketItem(
    //         state.formValue,
    //         state.currencies || [],
    //         state.summary
    //       )
    //     );
    //     if (state.onCurrencyChange) {
    //       state.onCurrencyChange(null);
    //     }
    //     if (state.onCurrencyAmountChange) {
    //       state.onCurrencyAmountChange(null);
    //     }
    //
    //     if (state.onSettlementSourceChange) {
    //       state.onSettlementSourceChange(null);
    //     }
    //     return {
    //       ...state,
    //       clickedActionButton: false,
    //       isDirty: false,
    //       formValue: {
    //         branchId: state.formValue.branchId,
    //         currencyAmount: NaN,
    //         selectedDate: state.defaultRequiredDate,
    //         settlementSource: state.formValue.settlementSource
    //       }
    //     };
    //   } else {
    //     return {
    //       ...state,
    //       clickedActionButton: true,
    //       isDirty: true
    //     };
    //   }
    // }
    // case "AddToBasketReturns": {
    //   if (
    //     state.onAddToBasket &&
    //     state.formValue.branchId &&
    //     state.formValue.currency &&
    //     state.formValue.currencyAmount
    //   ) {
    //     state.onAddToBasket(
    //       convertToBasketItem(
    //         state.formValue,
    //         state.currencies || [],
    //         state.summary
    //       )
    //     );
    //     if (state.onCurrencyChange) {
    //       state.onCurrencyChange(null);
    //     }
    //     if (state.onCurrencyAmountChange) {
    //       state.onCurrencyAmountChange(null);
    //     }
    //     return {
    //       ...state,
    //       isDirty: false,
    //       clickedActionButton: false,
    //       formValue: {
    //         branchId: state.formValue.branchId,
    //         currencyAmount: NaN,
    //         selectedDate: state.defaultRequiredDate
    //       }
    //     };
    //   } else {
    //     return {
    //       ...state,
    //       clickedActionButton: true,
    //       isDirty: true
    //     };
    //   }
    // }
    case "Clear": {
      return {
        ...state,
        isDirty: false,
        formValue: {
          currencyAmount: NaN,
          selectedDate: state.defaultRequiredDate,
          settlementSource: 0
        }
      };
    }
    case "SetDirty": {
      return {
        ...state,
        isDirty: action && action.payload && action.payload.isDirty
      };
    }
    case "SubmitBasket": {
      return {
        ...state,
        openConfirmDialog: true
      };
    }
    case "CancelSubmitBasket": {
      return {
        ...state,
        openConfirmDialog: false
      };
    }
    // case "SubmitOrder": {
    //   if (state.onConfirmOrder) {
    //     state.onConfirmOrder();
    //   }
    //   return state;
    // }
    case "SetProps": {
      const newProps = action.payload;
      let newState = {
        ...state,
        ...action.payload
      };
      if (
        newProps &&
        newProps.submissionResultItems &&
        newProps.submissionResultItems !== state.submissionResultItems
      ) {
        newState = {
          ...newState,
          openConfirmDialog: false,
          openSubmitDialog: true,
          formValue: {}
        };
      }
      return newState;
    }
    default: {
      throw new Error("Unknown action type: " + action.type);
    }
  }
};

export default reducer as Reducer<State, ReducerAction>;
